import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { findYoutubeChannel } from '@/components/UBSafelist/api';
import { safelistKeys } from '@/utils/queryKeys';

import type { YouTubeChannelData } from '@/components/UBSafelist/types';

export const useYoutubeChannelData = (selectedChannel: string) =>
  useQuery<YouTubeChannelData | null>({
    queryKey: safelistKeys.youtubeChannelData(selectedChannel),
    placeholderData: keepPreviousData,
    queryFn: async () => {
      if (!selectedChannel) {
        return null;
      }

      const results = await findYoutubeChannel(selectedChannel);

      return {
        ...results,
        channelId: selectedChannel,
      };
    },
  });
